<div class="dashboardDeleteOverlay">
    <div class="bg"></div>

    <div class="content">
        <div class="closeHolser">
            <div class="close" (click)="close()">
                <mat-icon>close</mat-icon>
            </div>
        </div>

        <div class="confirm">
            Are you sure you want to cancel the booking?
        </div>
        <div class="buttonsWrap">

            <div class="buttons">
                <div class="cancel" (click)="close()">
                    <div class="label">No</div>
                </div>
    
                <div class="save" >
                    <div class="label" (click)="confirm()">Cancel Booking</div>
                </div>
            </div>
        </div>
    </div>
</div>